import { initAddToCartSuccessModalFocus, initCalendarSheets } from './scripts/calendar.js'
import { initPollPopup } from './scripts/poll-popup'

initCalendarSheets()
initAddToCartSuccessModalFocus()
initPollPopup()
